export const colors = [
    '#f54242',
    '#f5ad42',
    '#eff542',
    '#8df542',
    '#42f5bc',
    '#42daf5',]

export const getRotation = (start: any, end: any) => {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const rotation = Math.atan2(dy, dx);
    return rotation;
}

export const getAmountWidth = (p100: number, value: number) => {
    return (value / p100 * 100);
}

export const getColor = (value: number, colorTable: any[]) => {
    for (let i = 0; i < colorTable.length; i++) {
        let item = colorTable[i];
        if (value >= item.first && value <= item.last) {
            return item;
        }
    }
    return {color: '#ffffff'};
}

const hexToRgb = (hex: string): [number, number, number] => {
    const h = hex.replace('#', '');
    const full = h.length === 3
        ? h.split('').map(c => c + c).join('')
        : h.padEnd(6, '0').slice(0, 6);
    return [
        parseInt(full.slice(0, 2), 16),
        parseInt(full.slice(2, 4), 16),
        parseInt(full.slice(4, 6), 16),
    ];
};

const rgbToHex = (r: number, g: number, b: number): string => {
    const toH = (n: number) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0');
    return `#${toH(r)}${toH(g)}${toH(b)}`;
};

export const interpolateColor = (a: string, b: string, t: number): string => {
    const [ar, ag, ab] = hexToRgb(a);
    const [br, bg, bb] = hexToRgb(b);
    return rgbToHex(ar + (br - ar) * t, ag + (bg - ag) * t, ab + (bb - ab) * t);
};

export interface GradientStop { position: number; color: string; }

// Evaluate the gradient at normalized position t in [0, 1].
// Beyond the leftmost/rightmost stop the result is clamped to that stop's color,
// so an end pin moved inward produces a flat-color region between the boundary
// and that pin (as requested by the user).
export const sampleGradient = (gradient: GradientStop[], t: number): string => {
    if (!gradient || gradient.length === 0) return '#ffffff';
    const sorted = [...gradient].sort((a, b) => a.position - b.position);
    if (t <= sorted[0].position) return sorted[0].color;
    if (t >= sorted[sorted.length - 1].position) return sorted[sorted.length - 1].color;
    for (let i = 0; i < sorted.length - 1; i++) {
        const a = sorted[i], b = sorted[i + 1];
        if (t >= a.position && t <= b.position) {
            const span = b.position - a.position;
            const local = span <= 0 ? 0 : (t - a.position) / span;
            return interpolateColor(a.color, b.color, local);
        }
    }
    return sorted[sorted.length - 1].color;
};

// Sample the gradient into a fine bucketed colorTable so the existing
// `getColor(value, colorTable)` lookup keeps working unchanged.
export const gradientToColorTable = (gradient: GradientStop[], maxValue: number, segments = 64) => {
    const max = Math.max(maxValue, 1e-9);
    const out: { first: number; last: number; color: string }[] = [];
    for (let i = 0; i < segments; i++) {
        const t0 = i / segments;
        const t1 = (i + 1) / segments;
        // Use the midpoint to pick a representative color for the bucket.
        const tm = (t0 + t1) / 2;
        out.push({
            first: t0 * max,
            last: i === segments - 1 ? max : t1 * max,
            color: sampleGradient(gradient, tm),
        });
    }
    return out;
};

